import { render, staticRenderFns } from "./HPTSection.vue?vue&type=template&id=5ba93df8&scoped=true"
import script from "./HPTSection.vue?vue&type=script&lang=js"
export * from "./HPTSection.vue?vue&type=script&lang=js"
import style0 from "./HPTSection.vue?vue&type=style&index=0&id=5ba93df8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba93df8",
  null
  
)

export default component.exports